'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../external/@babel/runtime/helpers/esm/extends.js');

var objectWithoutProperties = require('../../external/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var objectSpread2 = require('../../external/@babel/runtime/helpers/esm/objectSpread2.js');

var classCallCheck = require('../../external/@babel/runtime/helpers/esm/classCallCheck.js');

var createClass = require('../../external/@babel/runtime/helpers/esm/createClass.js');

var assertThisInitialized = require('../../external/@babel/runtime/helpers/esm/assertThisInitialized.js');

var inherits = require('../../external/@babel/runtime/helpers/esm/inherits.js');

var createSuper = require('../../external/@babel/runtime/helpers/esm/createSuper.js');

var defineProperty = require('../../external/@babel/runtime/helpers/esm/defineProperty.js');

var React = require('react');

var PropTypes = require('prop-types');

var index = require('../../external/classnames/index.js');

var CarouselControl = require('./CarouselControl/CarouselControl.js');

var CarouselIndicator = require('./CarouselIndicator/CarouselIndicator.js');

var CarouselIndicators = require('./CarouselIndicators/CarouselIndicators.js');

var CarouselContext = require('./CarouselContext.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["activeItem", "children", "className", "controlsColor", "controlsOutside", "card", "cardSize", "loop", "showControls", "showIndicators", "slide", "stopRight", "tag", "indicatorLabels"];

var Carousel = /*#__PURE__*/function (_Component) {
  inherits['default'](Carousel, _Component);

  var _super = createSuper['default'](Carousel);

  function Carousel() {
    var _this;

    classCallCheck['default'](this, Carousel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    defineProperty['default'](assertThisInitialized['default'](_this), "state", {
      activeItem: _this.props.activeItem,
      initialLength: _this.props.length,
      move: false
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "carouselRef", /*#__PURE__*/React__default['default'].createRef());
    defineProperty['default'](assertThisInitialized['default'](_this), "next", function () {
      var _this$state = _this.state,
          activeItem = _this$state.activeItem,
          initialLength = _this$state.initialLength;
      var nextIndex = activeItem + 1;
      var nextItem = nextIndex === initialLength ? 0 : nextIndex;

      _this.goToIndex(nextItem);
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "prev", function () {
      var _this$state2 = _this.state,
          activeItem = _this$state2.activeItem,
          initialLength = _this$state2.initialLength;
      var prevIndex = activeItem - 1;
      var prevItem = prevIndex < 0 ? initialLength - 1 : prevIndex;

      _this.goToIndex(prevItem);
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "goToIndex", function (item) {
      _this.setState(objectSpread2['default'](objectSpread2['default']({}, _this.state), {}, {
        activeItem: item,
        move: true
      }));
    });
    return _this;
  }

  createClass['default'](Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var length = this.props.length;
      this.setState({
        initialLength: length
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var length = this.props.length;
      var activeItem = this.state.activeItem;
      var initialLength = length;

      if (prevState.initialLength !== length) {
        this.setState({
          initialLength: initialLength
        });
      }

      if (prevState.activeItem !== activeItem) {
        this.setState({
          activeItem: activeItem
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props;
      _this$props.activeItem;
      var children = _this$props.children,
          className = _this$props.className,
          controlsColor = _this$props.controlsColor,
          controlsOutside = _this$props.controlsOutside;
      _this$props.card;
      var cardSize = _this$props.cardSize,
          loop = _this$props.loop,
          showControls = _this$props.showControls,
          showIndicators = _this$props.showIndicators,
          slide = _this$props.slide,
          stopRight = _this$props.stopRight,
          Tag = _this$props.tag,
          indicatorLabels = _this$props.indicatorLabels,
          attributes = objectWithoutProperties['default'](_this$props, _excluded);
      var _this$state3 = this.state,
          initialLength = _this$state3.initialLength,
          activeItems = _this$state3.activeItem,
          move = _this$state3.move;
      var classes = index['default']('carousel', slide && 'carousel-slide', move && 'move', className);
      var controlClasses = index['default'](controlsOutside ? 'lanl-carousel-controls-outside' : 'lanl-carousel-controls-inside', "lanl-carousel-controls-".concat(controlsColor));
      var CarouselIndicatorsArray = [];

      var _loop = function _loop(i) {
        var activeItem = _this2.state.activeItem;
        CarouselIndicatorsArray.push( /*#__PURE__*/React__default['default'].createElement(CarouselIndicator.CarouselIndicator, {
          key: i,
          active: activeItem === i,
          onClick: function onClick() {
            return _this2.goToIndex(i);
          },
          indicatorLabel: indicatorLabels[i]
        }));
      };

      for (var i = 0; i < initialLength; i++) {
        _loop(i);
      }

      return /*#__PURE__*/React__default['default'].createElement(CarouselContext['default'].Provider, {
        value: {
          activeItem: activeItems,
          cardSize: cardSize,
          slide: slide,
          length: initialLength
        }
      }, /*#__PURE__*/React__default['default'].createElement(Tag, _extends['default']({
        "data-testid": "lanl-carousel",
        ref: this.carouselRef
      }, attributes, {
        className: classes,
        "aria-label": "carousel"
      }), children, showControls && /*#__PURE__*/React__default['default'].createElement("div", {
        className: controlClasses
      }, /*#__PURE__*/React__default['default'].createElement(CarouselControl.CarouselControl, {
        iconLeft: true,
        direction: "prev",
        loop: loop,
        role: "button",
        onClick: this.prev
      }), /*#__PURE__*/React__default['default'].createElement(CarouselControl.CarouselControl, {
        iconRight: true,
        direction: "next",
        loop: loop,
        role: "button",
        onClick: this.next,
        stopRight: stopRight
      })), showIndicators && /*#__PURE__*/React__default['default'].createElement(CarouselIndicators.CarouselIndicators, null, CarouselIndicatorsArray)));
    }
  }]);
  return Carousel;
}(React.Component);

Carousel.propTypes = {
  activeItem: PropTypes__default['default'].number,
  card: PropTypes__default['default'].bool,
  cardSize: PropTypes__default['default'].number,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  controlsColor: PropTypes__default['default'].oneOf(['standard', 'white']),
  controlsOutside: PropTypes__default['default'].bool,
  indicatorLabels: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  length: PropTypes__default['default'].number,
  loop: PropTypes__default['default'].bool,
  showControls: PropTypes__default['default'].bool,
  showIndicators: PropTypes__default['default'].bool,
  slide: PropTypes__default['default'].bool,
  stopRight: PropTypes__default['default'].number,
  tag: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string])
};
Carousel.defaultProps = {
  card: false,
  controlsColor: 'standard',
  controlsOutside: false,
  loop: false,
  showControls: true,
  showIndicators: true,
  slide: true,
  stopRight: 1,
  tag: 'div',
  indicatorLabels: []
};
exports.Carousel = Carousel;
exports['default'] = Carousel;